module.exports = __webpack_public_path__ + "static/media/volume-off.29eb9f0f.svg";